export const jsErrSym = 'jserror';
export const genericServerErr = 'Internal Server Error';
export const ignorableJsErrMsgPatterns = [
    `Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.`,
    'Script error.',
    'The user aborted a request.',
    'Load failed',
    `Can't find variable: EmptyRanges`,
    genericServerErr,
    'The fetching process for the media resource',
    'The media resource indicated by the src attribute',
    'The operation was aborted.',
    'Hydration failed because the server rendered',
    'Failed to connect to MetaMask',
    'Failed to fetch',
    'The requesting page is not visible',
    /Response not successful: Received status code (40[04]|50[234])/,
];
export const isIgnorableJsErrMsg = (msg) => ignorableJsErrMsgPatterns.some(p => p instanceof RegExp ? p.test(msg ?? '') : (msg ?? '').includes(p));
